import React from "react";
import SubPageLayout from "../../../components/shared/SubPageLayout";

const InsuranceCoverage = () => {
  const breadcrumbItems = [
    { label: "Education & Licensing", link: "/education-licensing" },
    {
      label: "Insurance Coverage",
      link: "/education-licensing/insurance-coverage",
    },
  ];

  return (
    <SubPageLayout
      title="Insurance Coverage"
      subtitle="Manage your professional insurance coverage and requirements"
      breadcrumbItems={breadcrumbItems}
    >
      <div className="text-center py-20">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          Insurance Coverage Under Construction
        </h1>
        <p className="text-xl text-gray-600 dark:text-gray-400">This feature is coming soon!</p>
      </div>
    </SubPageLayout>
  );
};

export default InsuranceCoverage;
